import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// API to fetch daily closing summary
export const getDailyClosingSummary = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DayClosing/get-summary`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching daily closing summary:", error);
    throw error;
  }
};

// API to fetch daily closing transactions
export const getDailyClosingTransactions = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DayClosing/get-transactions`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching daily closing transactions:", error);
    throw error;
  }
};

// API to save day closing or holiday
export const saveDayClosing = async (request = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DayClosing/save`, request, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error saving day closing:", error);
    throw error;
  }
};

// API to check if a date is closed or holiday
export const checkDayClosing = async (request = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DayClosing/check`, request, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error checking day closing:", error);
    throw error;
  }
};

// API to update transaction amount
export const updateTransactionAmount = async (request = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DayClosing/update-transaction-amount`, request, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error updating transaction amount:", error);
    throw error;
  }
};

// API to get opening balance (last closed day's closing balance)
export const getDailyClosingOpeningBalance = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DayClosing/get-opening-balance`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error getting opening balance:", error);
    throw error;
  }
};

// API to export daily closing to Excel
export const exportDailyClosingToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DayClosing/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const dateStr = filter.closingDate ? new Date(filter.closingDate).toISOString().slice(0,10).replace(/-/g, '') : '';
    const typeStr = filter.transactionType || 'ALL';
    link.setAttribute('download', `DailyClosing_${typeStr}_${dateStr}_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting daily closing:", error);
    throw error;
  }
};

// API to get X Report data
export const getXReport = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DayClosing/get-x-report`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching X Report:", error);
    throw error;
  }
};

// API to get Z Report data
export const getZReportData = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/DayClosing/get-z-report-data`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Z Report:", error);
    throw error;
  }
};

